export const MIN_NUMBER_VALUE = 0;

export const HANDLING_UNITS_EDITOR_FF = 'enable_vehicle_profile_handling_units_editor';
